module.exports = "<p>\n  patientstatusgrid works!\n</p>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/Pages/tasks/patientstatus/patientstatusgrid/patientstatusgrid.component.html
// module id = ./src/app/Pages/tasks/patientstatus/patientstatusgrid/patientstatusgrid.component.html
// module chunks = main